/* Shared luminance-aware icon color helper.
   Returns a color that's guaranteed readable against the user's theme background.
   Used by both <PublicProfile> and <OrbitHeader> so the same TikTok-on-dark
   contrast bug can never silently come back in one place. */
export function getReadableIconColor(brandColor, themeBgHex) {
  if (!brandColor) return brandColor;
  const hex = brandColor.replace('#', '');
  if (hex.length < 6) return brandColor;
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  const bg = (themeBgHex || '#ffffff').replace('#', '');
  let br = 255, bgG = 255, bb = 255;
  if (bg.length >= 6) {
    br = parseInt(bg.substring(0, 2), 16);
    bgG = parseInt(bg.substring(2, 4), 16);
    bb = parseInt(bg.substring(4, 6), 16);
  }
  const bgLum = (br * 299 + bgG * 587 + bb * 114) / 1000;
  const iconLum = (r * 299 + g * 587 + b * 114) / 1000;

  // If icon and background luminance are within 60 points → low contrast.
  // Pick high-contrast neutral instead.
  if (Math.abs(iconLum - bgLum) < 60) {
    return bgLum < 128 ? '#ffffff' : '#111111';
  }
  // Pure dark icons on dark theme: still flip to white
  if (bgLum < 128 && iconLum < 60) return '#ffffff';
  return brandColor;
}
